import React, { useEffect, useState } from 'react';
import Reveal from 'react-reveal/Zoom';
import { graphql, Link } from 'gatsby';
import { Col, Container, Row } from 'react-bootstrap';

import './~single.scss';
import Layout from '../../layouts/default';
import SEO from '../../components/seo';

import CarouselRibbon from '../../components/paragraph/carousel_ribbon';
import Breadcrumbs from '../../components/breadcrumbs';
import Header from './header';
import Facts from './facts';
import Overview from './overview';
import ProblemSolution from './problem_solution';
import Testimonial from './testimonial';
import Outcomes from './outcomes';

const CaseStudy = (props) => {
  const caseStudy = props.data.allNodeCaseStudy.edges[0].node;
  const [initialised, setInitialised] = useState(false);
  const [field_facts, setFacts] = useState(undefined);
  const [field_overview, setOverview] = useState(undefined);
  const [field_problem_solution, setProblemSolution] =
    useState(undefined);
  const [field_testimonial, setTestimonial] = useState(undefined);
  const [field_outcomes, setOutcomes] = useState(undefined);
  const [field_organisation, setOrgInfo] = useState(undefined);
  const [field_organisation_icon, setOrgIcon] = useState(undefined);
  const [field_facts_image, setFactImage] = useState(undefined);
  const [field_problem_solution_text, setProblemSolnText] =
    useState(undefined);
  const [field_outcomes_image, setOutcomesImage] =
    useState(undefined);

  useEffect(() => {
    setFacts(caseStudy.relationships.field_facts);
    setOverview(caseStudy.relationships.field_overview);
    setProblemSolution(
      caseStudy.relationships.field_problem_solution
    );
    setTestimonial(caseStudy.field_testimonial);
    setOutcomes(caseStudy.relationships.field_outcomes);
    setOrgInfo(caseStudy.relationships.field_organisation);
    setOrgIcon(
      caseStudy.relationships.field_organisation.relationships
        .field_icon_dark
    );
    setFactImage(
      caseStudy.relationships.field_facts.relationships.field_image
    );
    setProblemSolnText(
      caseStudy.relationships.field_problem_solution.relationships
        .field_image_s_text
    );
    setOutcomesImage(
      caseStudy.relationships.field_outcomes.relationships
        .field_background_image
    );
    setInitialised(true);
  }, [caseStudy]);

  const title = caseStudy.title;
  const location = props.location.pathname;
  const excerpt = caseStudy.field_excerpt;
  const image =
    caseStudy.relationships.field_image.relationships
      .field_media_image.localFile.publicURL;

  if (initialised) {
    return (
      <Layout id="case-studies">
        <SEO
          title={`Experience: ${title}`}
          description={excerpt}
          image={image}
        />
        <Breadcrumbs path={location} />
        <Header
          id="case-studies__header"
          title={title}
          field_organisation={field_organisation}
          field_organisation_icon={field_organisation_icon}
        />
        {field_facts && (
          <Facts
            id="case-studies__facts"
            className="bg-gradient--veritec-blue"
            field_facts={field_facts}
            field_facts_image={field_facts_image}
          />
        )}

        {field_overview && (
          <Overview
            id="case-studies__overview"
            field_overview={field_overview}
          />
        )}

        {field_problem_solution && field_problem_solution_text && (
          <ProblemSolution
            id="case-studies__problemsolution"
            className="bg-gradient--grey-white"
            field_problem_solution={field_problem_solution}
            field_problem_solution_text={field_problem_solution_text}
          />
        )}
        {field_testimonial && (
          <Testimonial
            id="case-studies__testimonial"
            field_testimonial={field_testimonial}
          />
        )}
        {field_outcomes && field_outcomes_image && (
          <Outcomes
            id="case-studies__outcomes"
            className="dark"
            field_outcomes={field_outcomes}
            field_outcomes_image={field_outcomes_image}
          />
        )}
        <CaseStudyHappyClients />
        <CaseStudyCallToAction />
      </Layout>
    );
  } else {
    return <div> </div>;
  }
};

{
  /* OUR HAPPY CLIENTS
   */
}
const CaseStudyHappyClients = (props) => {
  return (
    <section>
      <Container>
        <Row>
          <Col xs={12} style={{ paddingBottom: '15px' }}>
            <h2> Our Customers </h2>
            <p>
              Please get in touch to learn how we work with our
              customers to power innovation through our technology
              expertise.
            </p>
          </Col>
          <Col xs={12}>
            <CarouselRibbon type={'Case Study (Ribbon)'} />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

{
  /* CALL TO ACTION
   */
}
const CaseStudyCallToAction = (props) => {
  return (
    <section
      id="call_to_action"
      className={`dark bg-gradient--navy-blue`}
    >
      <Reveal>
        <Container>
          <Row>
            <Col>
              <h3>
                We deliver outcome based solutions to improve every
                aspect of your organisation.
              </h3>
              <Link to={'/contact'} className="btn btn-primary">
                Get in touch
              </Link>
            </Col>
          </Row>
        </Container>
      </Reveal>
    </section>
  );
};

export default CaseStudy;

export const query = graphql`query ($id: String!) {
  allNodeCaseStudy(filter: {id: {eq: $id}}) {
    edges {
      node {
        id
        internal {
          type
        }
        path {
          alias
        }
        drupal_id
        created
        title
        field_excerpt
        field_testimonial {
          processed
          value
        }
        relationships {
          field_organisation {
            title
            field_link {
              uri
            }
            relationships {
              field_icon_dark {
                relationships {
                  field_media_image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(width: 400, layout: CONSTRAINED)
                      }
                      publicURL
                    }
                  }
                }
              }
            }
          }
          field_image {
            field_media_image {
              alt
            }
            relationships {
              field_media_image {
                localFile {
                  publicURL
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                  }
                }
              }
            }
          }
          field_facts {
            field_html {
              processed
              value
            }
            relationships {
              field_image {
                field_media_image {
                  alt
                }
                relationships {
                  field_media_image {
                    localFile {
                      publicURL
                      childImageSharp {
                        gatsbyImageData(layout: FULL_WIDTH)
                      }
                    }
                  }
                }
              }
            }
          }
          field_overview {
            field_html {
              processed
              value
            }
          }
          field_problem_solution {
            relationships {
              field_image_s_text {
                field_html {
                  processed
                  value
                }
                relationships {
                  field_image {
                    field_media_image {
                      alt
                    }
                    relationships {
                      field_media_image {
                        localFile {
                          publicURL
                          childImageSharp {
                            gatsbyImageData(height: 60, layout: FIXED)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          field_outcomes {
            relationships {
              field_background_image {
                field_media_image {
                  alt
                }
                relationships {
                  field_media_image {
                    localFile {
                      publicURL
                      childImageSharp {
                        gatsbyImageData(layout: FULL_WIDTH)
                      }
                    }
                  }
                }
              }
              field_image_s_text_link {
                field_html {
                  processed
                  value
                }
                relationships {
                  field_image {
                    field_media_image {
                      alt
                    }
                    relationships {
                      field_media_image {
                        localFile {
                          publicURL
                          childImageSharp {
                            gatsbyImageData(height: 60, layout: FIXED)
                          }
                        }
                      }
                    }
                  }
                }
                field_link {
                  title
                  uri
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
